import { SvgIconProps } from '@mui/material/SvgIcon';
import { ContentCut } from '@mui/icons-material';

const ObjectIcon = (props: SvgIconProps) => {
  return <ContentCut {...props} />;
};

export default ObjectIcon;
